export function getPairingCode(state) {
  return state.pairingManually.pairingCode;
}
